import { render } from "./SeparateTestBlog.vue?vue&type=template&id=6e6197a9&scoped=true"
import script from "./SeparateTestBlog.vue?vue&type=script&lang=js"
export * from "./SeparateTestBlog.vue?vue&type=script&lang=js"

import "./SeparateTestBlog.vue?vue&type=style&index=0&id=6e6197a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6197a9"]])

export default __exports__